module.exports = __webpack_public_path__ + "static/aurochs-48b059a81d9ddb59fdf2e95ae297eb96.jpeg";